module.exports = __webpack_public_path__ + "assets/adpoly-it-lms-bulk-upload-template.db108e4b.xlsx";